import PropTypes from "prop-types";
import locale from "rc-pagination/lib/locale/en_US";

import * as S from "./styled";

const { Pagination } = S;

// copied from https://github.com/react-component/pagination/blob/master/src/Pagination.jsx#L32
Pagination.propTypes = {
  className: PropTypes.string,
  current: PropTypes.number,
  defaultCurrent: PropTypes.number,
  defaultPageSize: PropTypes.number,
  disabled: PropTypes.bool,
  hideOnSinglePage: PropTypes.bool,
  itemRender: PropTypes.func,
  jumpNextIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  jumpPrevIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  // eslint-disable-next-line react/forbid-prop-types
  locale: PropTypes.object,
  nextIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  onChange: PropTypes.func,
  onShowSizeChange: PropTypes.func,
  pageSize: PropTypes.number,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.string),
  prefixCls: PropTypes.string,
  prevIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  selectComponentClass: PropTypes.func,
  showLessItems: PropTypes.bool,
  showPrevNextJumpers: PropTypes.bool,
  showQuickJumper: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  showSizeChanger: PropTypes.bool,
  showTitle: PropTypes.bool,
  showTotal: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  total: PropTypes.number
};

Pagination.defaultProps = {
  className: "",
  defaultCurrent: 1,
  defaultPageSize: 10,
  hideOnSinglePage: false,
  prefixCls: "rc-pagination",
  selectComponentClass: null,
  selectPrefixCls: "rc-select",
  showLessItems: false,
  showPrevNextJumpers: true,
  showQuickJumper: false,
  showSizeChanger: false,
  showTitle: true,
  locale,
  style: {},
  total: 0
};

export default Pagination;
